<component :is="tag" :title="anonymousTitle" :class="{'text-numeric': isAnonymous}" :inner-html.prop="anonymousText | mark(query)"/>